import gql from 'graphql-tag';

const UPDATE_CAMPAIGN_STATUS = gql`
  mutation updateCampaignStatus($where: CampaignWhereUniqueInput!, $data: CampaignUpdateInput!) {
    updateCampaign(where: $where, data: $data) {
      id
      status
      demandSidePlatform
      adProviderId
      maxBid
      isLaunchProgrammatically
    }
  }
`;

export default UPDATE_CAMPAIGN_STATUS;
